import Clipboard from 'clipboard';

(function ($) {
    const shareUrlFacebook = 'https://www.facebook.com/sharer/sharer.php?u=';
    const shareUrlTwitter = 'https://twitter.com/intent/tweet?';
    const shareUrlLinkedin = 'https://www.linkedin.com/shareArticle?mini=true&';

    // function fb share
    window.fbShare = function (url) {
        const winWidth = 630;
        const winHeight = 650;
        const winTop = window.screen.height / 2 - winHeight / 2;
        const winLeft = window.screen.width / 2 - winWidth / 2;
        window.open(shareUrlFacebook + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
    };
    // function twitter share
    window.twitterShare = function (url, question) {
        const winWidth = 630;
        const winHeight = 700;
        const winTop = window.screen.height / 2 - winHeight / 2;
        const winLeft = window.screen.width / 2 - winWidth / 2;
        window.open(shareUrlTwitter + 'text=' + question + '&url=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
    };
    // function linkedin share
    window.linkedinShare = function (url, question) {
        const winWidth = 630;
        const winHeight = 650;
        const winTop = window.screen.height / 2 - winHeight / 2;
        const winLeft = window.screen.width / 2 - winWidth / 2;
        window.open(shareUrlLinkedin + 'summary=' + question + '&url=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
    };

    window.getShareUrl = function (socials) {
        let url = socials.data('url');
        if (!url.includes(':') && $('base').length) {
            url = $('base').attr('href') + url;
        }
        return url;
    };

    window.initSocialShares = function (target) {
        const $target = target ? $(target).find('.socials') : $('.socials');

        // baseURI
        $target.find('.share__facebook').click(function (event) {
            event.preventDefault();
            const socials = $(this).parents('.socials');
            const url = getShareUrl(socials);
            fbShare(url);
        });
        $target.find('.share__twitter').click(function (event) {
            event.preventDefault();
            const socials = $(this).parents('.socials');
            const url = getShareUrl(socials);
            const name = socials.data('name');
            twitterShare(url, name);
        });
        $target.find('.share__linkedin').click(function (event) {
            event.preventDefault();
            const socials = $(this).parents('.socials');
            const url = getShareUrl(socials);
            const name = socials.data('name');
            linkedinShare(url, name);
        });
        const clipboard = new Clipboard('.share__url');
        clipboard.on('success', (e) => {
            e.trigger.classList.add('copied');

            setTimeout(() => {
                e.trigger.classList.remove('copied');
            }, 1200);
        });
    };

    const sharePrompt = function (el, e) {
        // Native
        if (navigator.share) {
            e.preventDefault();

            const socials = $(el).parent().find('.socials');
            const name = socials.data('name');
            const url = getShareUrl(socials);
            navigator
                .share({
                    title: name,
                    url,
                })
                .then(() => {
                    // console.log('Partage réussi');
                })
                .catch((error) => {
                    // console.error('Erreur lors du partage:', error);
                });
        } else { // Fallback
            initSocialShares();
        }
    };

    $('.share-toolbar__btn').on('click', function (e) {
        sharePrompt(this, e);
    });
}(jQuery));
